import { get, post } from './http-calls';

export const UpdateUserDetailsFranchise = async (operatorID, FranchiseVM, isUsedSalesExec, isNewSalesExec) => {
    let res = await post(
        `UserDetailsFranchise`,
        {
            operatorID: operatorID,
            FranchiseVM: FranchiseVM,
            isUsedSalesExec: isUsedSalesExec,
            isNewSalesExec: isNewSalesExec
        },
        { useAuthToken: true }
    );
    return res;
};

export const getUserDetailsFranchise = async (operatorID) => {
    let res = await get(`UserDetailsFranchise/GetDetails?Id=${operatorID}`, { useAuthToken: true });
    return res;
};

export const getMessagesWithoutSignature_List = async (operatorID) => {
    let res = await get(`MessagesMaster/MessagesWithoutSignature_List`, { useAuthToken: true });
    return res;
};

export const UserMessageSignatures_AddUpdate = async (data) => {
    let res = await post(`MessagesMaster/UserMessageSignatures_AddUpdate`, data, { useAuthToken: true });
    return res;
};
